import React, { useState } from 'react';
import ListaCategorias from './ListaCategorias';
import VistaCategoria from './VistaCategoria';
import TablaGeneral from './TablaGeneral';
import CopaOro from './CopaOro';
import CopaPlata from './CopaPlata';

const GestionTorneo = ({ isAdmin, onAdminLogout, onVolverMenu }) => {
  const [view, setView] = useState('categorias'); // categorias, categoria, tabla-general, copa-oro, copa-plata
  const [categoriaActual, setCategoriaActual] = useState(null);

  const handleSelectCategoria = (categoria) => {
    setCategoriaActual(categoria);
    setView('categoria');
  };

  return (
    <div>
      <div className="nav-buttons">
        <button className="primary" onClick={() => setView('categorias')} data-testid="categorias-btn">
          📋 Categorías
        </button>
        <button className="primary" onClick={() => setView('tabla-general')} data-testid="tabla-general-btn">
          🏆 Tabla General
        </button>
        <button className="primary copa-oro-btn" onClick={() => setView('copa-oro')} data-testid="copa-oro-btn">
          🥇 Copa de Oro
        </button>
        <button className="primary copa-plata-btn" onClick={() => setView('copa-plata')} data-testid="copa-plata-btn">
          🥈 Copa de Plata
        </button>
        <button className="outline" onClick={onVolverMenu} data-testid="volver-menu-btn">
          🏠 Volver al Menú Principal
        </button>
      </div>

      {view === 'categorias' && (
        <ListaCategorias onSelectCategoria={handleSelectCategoria} />
      )}

      {view === 'categoria' && categoriaActual && (
        <VistaCategoria 
          categoria={categoriaActual} 
          isAdmin={isAdmin}
          onBack={() => setView('categorias')}
        />
      )}

      {view === 'tabla-general' && (
        <TablaGeneral isAdmin={isAdmin} />
      )}

      {view === 'copa-oro' && (
        <CopaOro isAdmin={isAdmin} />
      )}

      {view === 'copa-plata' && (
        <CopaPlata isAdmin={isAdmin} />
      )}
    </div>
  );
};

export default GestionTorneo;